import { AxiosRequestConfig } from "axios";
import { baseUrl, environment } from "../environment";
import { IResetPassword } from "../interfaces/projectDashboard.interface";
import { loginPayload, OfferLetterApprovalPayload, OfferLetterSignedListPayload, SeenNotificationPayload } from "../models/userModels";
import RestService from "./rest";

export const serviceClient = new RestService({
  baseURL: baseUrl,
});

export const LoginService = (data: loginPayload) => {
  return serviceClient.post(environment.urls.loginUrl, data);
};

export const LogoutService = () => {
  return serviceClient.get(environment.urls.logoutUrl);
};

export const generateCaptchaService = () => {
  return serviceClient.get(environment.urls.generateCaptcha);
};

export const resetPasswordService = (data: IResetPassword) => {
  return serviceClient.post(environment.urls.changePassword, data);
};

export const sendPasswordResetOtpService = (employeeId: string) => {
  return serviceClient.post(environment.urls.sendPasswordResetOtp, {
    employee_id: employeeId,
  });
};

export const verifyPasswordResetOtpService = (payload: {
  employee_id: string;
  otp: string;
  password: string;
}) => {
  return serviceClient.post(environment.urls.verifyOtpResetPassword, payload);
};

export const getAllNotificationListService = () => {
  return serviceClient.get(environment.urls.getAllNotification);
};
export const seenNotificationService = (payload: SeenNotificationPayload) => {
  return serviceClient.post(environment.urls.seenNotification, payload);
};
// Upload Signed Return Copy
export const UploadJoiningDocService = (
  payload: any,
  config?: AxiosRequestConfig<any> | undefined
) => {
  return serviceClient.postWithConfig(
    environment.urls.signedOfferLetterUpload as any,
    payload,
    config
  );
};
export const offerLetterSignedListService = (payload: OfferLetterSignedListPayload ) => {
  return serviceClient.post(environment.urls.offerLetterSignedList, payload);
};
export const SignedOfferLetterApprovalListService = (payload: OfferLetterApprovalPayload ) => {
  return serviceClient.post(environment.urls.offerLetterApproval, payload);
};

export const getApkDownloadUrlService = () => {
  return serviceClient.get(environment.urls.getApkDownloadUrl);
};